import { Avatar, AvatarFallback, AvatarImage } from '@/shared/components/ui/avatar'
import { cn } from '@/shared/lib/utils'
import { stableAvatarSrc } from './stableAvatarSrc'

function initialsOf(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean)
  const first = words[0]?.[0] ?? ''
  const last = words.length > 1 ? (words[words.length - 1]?.[0] ?? '') : ''
  return (first + last).toUpperCase() || '?'
}

export function PersonAvatar({
  name,
  photoUrl,
  photoFileId,
  size = 'md',
  className,
}: {
  name: string
  photoUrl?: string | null
  photoFileId?: string | null
  size?: 'sm' | 'md'
  className?: string
}) {
  const src = stableAvatarSrc(photoFileId, photoUrl)
  return (
    <Avatar
      className={cn(
        'shrink-0',
        size === 'md' ? 'h-[34px] w-[34px] rounded-lg' : 'h-6 w-6 rounded-full',
        className,
      )}
    >
      {src && <AvatarImage src={src} alt="" className="object-cover" />}
      <AvatarFallback
        className={cn(
          'bg-brand-accent-soft font-semibold text-brand-accent-ink',
          size === 'md' ? 'rounded-lg text-[11.5px]' : 'rounded-full text-[9.5px]',
        )}
      >
        {initialsOf(name)}
      </AvatarFallback>
    </Avatar>
  )
}
